import React from 'react';
import styled from 'styled-components';
import { registry } from '../../core/Registry.js';

const Wrapper = styled.div`
  width: ${props => props.width || '100%'};
  max-width: 700px;
  margin: ${props => props.align === 'center' ? '0 auto' : '0'};
  background: var(--glass-1);
  border: 1px solid var(--glass-border);
  border-radius: 16px;
  display: flex;
  overflow: hidden;
  position: relative;
  backdrop-filter: blur(10px);
  
  @media(max-width: 600px) {
    flex-direction: column;
  }
`;

const ImageArea = styled.div`
  flex: 1;
  background: radial-gradient(circle at center, rgba(6,182,212,0.2) 0%, rgba(0,0,0,0.5) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 30px;
  
  img {
    height: 180px;
    object-fit: contain;
    filter: drop-shadow(0 15px 25px rgba(0,0,0,0.5));
  }
`;

const ContentArea = styled.div`
  flex: 1.5;
  padding: 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const Badge = styled.div`
  position: absolute;
  top: 15px;
  left: 15px;
  background: var(--danger, #ef4444);
  color: #fff;
  font-weight: 800;
  text-transform: uppercase;
  font-size: 11px;
  padding: 4px 10px;
  border-radius: 4px;
  box-shadow: 0 4px 10px rgba(239, 68, 68, 0.4);
  z-index: 2;
`;

const Title = styled.h3`
  margin: 0 0 5px 0;
  color: var(--text-primary);
  font-size: 22px;
`;

const Subtitle = styled.p`
  margin: 0 0 15px 0;
  color: var(--text-muted);
  font-size: 13px;
`;

const PriceRow = styled.div`
  display: flex;
  align-items: baseline;
  gap: 10px;
  margin-bottom: 20px;
`;

const NewPrice = styled.div`
  font-size: 32px;
  font-weight: 900;
  color: var(--accent);
`;

const OldPrice = styled.div`
  font-size: 16px;
  color: var(--text-muted);
  text-decoration: line-through;
`;

const Button = styled.button`
  background: linear-gradient(135deg, var(--accent), var(--accent-neon));
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 12px 24px;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  align-self: flex-start;
  box-shadow: 0 4px 15px var(--accent-glow);
`;

const TopDealWidget = ({ node }) => {
  return (
    <Wrapper align={node.style?.desktop?.align} width={node.style?.desktop?.width}>
      <Badge>{node.content?.badge || 'Top Deal des Tages'}</Badge>
      <ImageArea>
        <img src={node.content?.img || 'https://via.placeholder.com/300x500/1e293b/00A9E0?text=Hardware'} alt="Deal" />
      </ImageArea>
      <ContentArea>
        <Title>{node.content?.title || 'Samsung Galaxy S24 Ultra'}</Title>
        <Subtitle>{node.content?.subtitle || 'Inklusive O2 Mobile L mit 70 GB+'}</Subtitle>
        <PriceRow>
          <NewPrice>{node.content?.price || '39,99 €'}</NewPrice>
          <OldPrice>{node.content?.oldPrice || '49,99 €'}</OldPrice>
        </PriceRow>
        <Button className="tef-bubbles">{node.content?.btnText || 'Zum Angebot'}</Button>
      </ContentArea>
    </Wrapper>
  );
};

registry.register('top_deal', {
  label: 'Top Deal Banner',
  icon: '🔥',
  category: 'tef_specific',
  defaultContent: {},
  defaultStyle: { desktop: { align: 'center', width: '100%' } },
  render: TopDealWidget,
  inspectorControls: [
    { tab: 'content', groups: [{ title: 'Inhalte', fields: [{name:'content.badge', label:'Badge', type:'text'}, {name:'content.title', label:'Titel', type:'text'}, {name:'content.subtitle', label:'Untertitel', type:'text'}, {name:'content.price', label:'Preis', type:'text'}, {name:'content.oldPrice', label:'Alter Preis', type:'text'}, {name:'content.img', label:'Bild URL', type:'text'}] }] },
    { tab: 'style', groups: [{ title: 'Layout', fields: [{name:'style.desktop.align', label:'Ausrichtung', type:'select', options:[{label:'Zentriert', value:'center'},{label:'Links', value:'flex-start'}]}] }] }
  ]
});
